import { chevronDownIcon, chevronUpIcon, plusIcon } from "@progress/kendo-svg-icons";

export const KendoIconSets = {
    chevrons: { chevronDown: chevronDownIcon, chevronUp: chevronUpIcon, plus: plusIcon }
};
